// Lightweight Supabase REST client for public (anon) reads.
// No dependency on @supabase/supabase-js — just fetch.

const SUPABASE_URL = 'https://setkcmorrurglnzfsetn.supabase.co';
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNldGtjbW9ycnVyZ2xuemZzZXRuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMwOTIyMTIsImV4cCI6MjA4ODY2ODIxMn0.zClwH4MbpG1fS2n7Wwidr96YazwbFlYr-U0eeHOI4zE';

/**
 * Query the Supabase REST API (PostgREST).
 * @param {string} table  – table name
 * @param {string} query  – PostgREST query string, e.g. "select=*&status=eq.active"
 * @returns {Promise<Array>}
 */
export async function supabaseQuery(table, query = 'select=*') {
  const url = `${SUPABASE_URL}/rest/v1/${table}?${query}`;
  const res = await fetch(url, {
    headers: {
      apikey: SUPABASE_ANON_KEY,
      Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
    },
  });
  if (!res.ok) throw new Error(`Supabase ${table}: ${res.status}`);
  return res.json();
}
